
import { DateTime } from 'luxon';

/**
 * Convert teaching duration string to numeric hours
 */
export const calculateClassDuration = (durationString: string): number => {
  if (durationString === '30 นาที') return 0.5;
  if (durationString === '1 ชม.') return 1;
  if (durationString === '1.30 ชม.') return 1.5;
  if (durationString === '2 ชม.') return 2;
  if (durationString === '2.30 ชม.') return 2.5;
  if (durationString === '3 ชม.') return 3;
  if (durationString === '4 ชม.') return 4;
  return 1; // Default to 1 hour if unknown format
};

/**
 * Calculate start and end dates with fixed timezone handling
 */
export const calculateClassTimes = (teachingDate: string, timeSlot: string, durationHours: number) => {
  // Parse the time slot into hours and minutes
  const [hours, minutes] = timeSlot.split(':').map(Number);

  const date = DateTime.fromISO(teachingDate).setZone('Asia/Bangkok');
  // Create a DateTime object with explicit Bangkok timezone
  const startDate = date.set({ hour: hours, minute: minutes });
  
  // Calculate end date by adding the duration in hours
  const endDate = startDate.plus({ hours: durationHours });
  console.log('Calculated dates:', {
    teachingDate,
    timeSlot,
    startDate: startDate.toISO(),
    endDate: endDate.toISO(),
    timezone: startDate.zoneName
  });
  
  return {
    startDate: startDate.toISO(),
    endDate: endDate.toISO()
  };
};

/**
 * Check if submission is on time (before 13:00 on the day after class)
 */
export const isSubmittedOnTime = (endDate: string | null): boolean => {
  if (!endDate) return true; // Default to true if no end date
  
  try {
    // Get class end time in Bangkok timezone
    const classEndTime = DateTime.fromISO(endDate).setZone('Asia/Bangkok');
    
    // Calculate the deadline (13:00 on the day after the class)
    const submissionDeadline = classEndTime.plus({ days: 1 }).set({ hour: 13, minute: 0, second: 0, millisecond: 0 });
    
    // Get current time in Bangkok timezone
    const now = DateTime.now().setZone('Asia/Bangkok');
    
    // Check if current time is before the deadline
    const isOnTime = now < submissionDeadline;
    
    console.log('Submission time check:', {
      classEndTime: classEndTime.toISO(),
      submissionDeadline: submissionDeadline.toISO(),
      currentTime: now.toISO(),
      isOnTime
    });
    
    return isOnTime;
  } catch (error) {
    console.error('Error calculating if submission is on time:', error);
    return true; // Default to true in case of error
  }
};
